import { AccredibleObjectWithId } from '@accredible-frontend-v2/models';
import { AccredibleApiService } from '@accredible-frontend-v2/services/api';
import { Injectable, signal } from '@angular/core';
import { catchError, map, of, take } from 'rxjs';

const SKILL_CATEGORIES_BASE_PATH = '/v1/recipient/skill_categories';
const INITIAL_LIMIT = 20;

@Injectable({
  providedIn: 'root',
})
export class SkillCategoriesService extends AccredibleApiService {
  readonly allCategories = signal<AccredibleObjectWithId[]>([]);

  readonly skillCategories = signal<AccredibleObjectWithId[]>([]);

  readonly selectedSkillCategories = signal<AccredibleObjectWithId[]>([]);

  constructor() {
    super();
    this._loadCategories();
  }

  filterBy(query: string): void {
    if (!query?.trim()) {
      this.skillCategories.set(this.allCategories());
      return;
    }

    const lowerQuery = query.toLowerCase();
    const filtered = this.allCategories().filter((cat) =>
      (cat.name as string).toLowerCase().includes(lowerQuery),
    );

    this.skillCategories.set(filtered);
  }

  updateSelected(skillCategories: AccredibleObjectWithId[]): void {
    this.selectedSkillCategories.set(skillCategories);
  }

  private _loadCategories(): void {
    this._get(SKILL_CATEGORIES_BASE_PATH)
      .pipe(
        take(1),
        map((res) => this._handleResponse(res, 'skill_categories') as AccredibleObjectWithId[]),
        catchError((err) => {
          this._handleError(err);
          return of([] as AccredibleObjectWithId[]);
        }),
      )
      .subscribe((data) => {
        this.allCategories.set(data);

        // only show first 20 initially
        this.skillCategories.set(data.slice(0, INITIAL_LIMIT));
      });
  }
}
